import { Guid } from '../store/model/guid';
import { HistoryItem } from '../store/reducers/currentSequencedFlowPositionReducer';
import { Hotspot, Item, Section } from '@ael/core-api';
import { Stack } from 'immutable';

export enum contentItemAction {
  MenuItemStartingMessage_Dismissed = 'MenuItemStartingMessage_Dismissed',
  NonSequencedContent_Dismissed = 'NonSequencedContent_Dismissed',
  NonSequencedContent_Selected = 'NonSequencedContent_Selected',
  NonSequencedContent_TabViewed = 'NonSequencedContent_TabViewed',
  NonSequencedContent_HotspotCounterTriggered = 'NonSequencedContent_HotspotCounterTriggered',
  Quiz_BlindMapIntroductionDismissed = 'Quiz_BlindMapIntroductionDismissed',
  Quiz_BlindMapIncorrectHit = 'Quiz_BlindMapIncorrectHit',
  Quiz_QuizClosed = 'Quiz_QuizClosed',
  Quiz_SubmitAnswer = 'Quiz_SubmitAnswer',
  SequencedContent_Dismiss = 'SequencedContent_Dismiss',
  SequencedContent_Display = 'SequencedContent_Display',
  SequencedContent_GoToSection_Selected = 'SequencedContent_GoToSection_Selected',
  SequencedContent_Finish_Selected = 'SequencedContent_Finish_Selected',
  SequencedContent_GoToPrevious_Selected = 'SequencedContent_GoToPrevious_Selected',
  SequencedContent_GoToNext_Selected = 'SequencedContent_GoToNext_Selected',
  SequencedContent_GoTo_Selected = 'SequencedContent_GoTo_Selected',
}

export const goToNextSelected = (selectedContentItem: Item) => ({
  type: contentItemAction.SequencedContent_GoToNext_Selected,
  payload: selectedContentItem,
});

export const goToPreviousSelected = {
  type: contentItemAction.SequencedContent_GoToPrevious_Selected,
};

export const finishSelected = (finishedItemId: Guid, isMobile: boolean) => ({
  type: contentItemAction.SequencedContent_Finish_Selected,
  payload: { finishedItemId, isMobile },
});

export const goToSectionSelected = (section: Section) => ({
  type: contentItemAction.SequencedContent_GoToSection_Selected,
  payload: section,
});

export const goToSelectedSequencedFlowContentItem = (
  contentItemId: string,
  sectionContentItemId: string | null,
  isMobile: boolean,
  history?: Stack<HistoryItem>
) => ({
  type: contentItemAction.SequencedContent_GoTo_Selected,
  payload: { contentItemId, sectionContentItemId, isMobile, history },
});

export const dismissSequencedFlow = () => ({
  type: contentItemAction.SequencedContent_Dismiss,
});

export const displaySequencedFlow = () => ({
  type: contentItemAction.SequencedContent_Display,
});

export const closeQuiz = (closedItemId: Guid, isMobile: boolean) => ({
  type: contentItemAction.Quiz_QuizClosed,
  payload: {
    finishedItemId: closedItemId,
    isMobile,
  },
});

export const loadNextQuestion = (nextQuestion: string | null) => ({
  type: contentItemAction.Quiz_SubmitAnswer,
  payload: {
    nextQuestion,
  },
});

export const blindMapIntroductionDismissed = (dontShowAgain: boolean) => ({
  type: contentItemAction.Quiz_BlindMapIntroductionDismissed,
  payload: {
    dontShowAgain,
  },
});

export const blindMapIncorrectHit = () => ({
  type: contentItemAction.Quiz_BlindMapIncorrectHit,
});

export const selectedNonSequencedItem = (content: Hotspot) => ({
  type: contentItemAction.NonSequencedContent_Selected,
  payload: content,
});

export const selectedNonSequencedPolygonItem = (content: Hotspot) => ({
  payload: content,
});

export const dismissedHotspot = {
  type: contentItemAction.NonSequencedContent_Dismissed,
};

export const viewedTab = (tabId: string, hotspotId: string) => ({
  type: contentItemAction.NonSequencedContent_TabViewed,
  payload: {
    viewedTabId: tabId,
    currentHotspot: hotspotId,
  },
});

export const hotspotCounterTriggered = () => ({
  type: contentItemAction.NonSequencedContent_HotspotCounterTriggered,
});
